export default __webpack_public_path__ + "static/media/addTestwhite.d02417b9.svg";